export default {

    /**
    * All kinds of Translator Helpers
    * computed (experimental) is used for caching purpose
    *
    */
    data: function () {
        return {
            BEAMTER: {
                B: "B",
                N: "N"
            },

            PRODUKT: {
                PRIVAT: "P",
                VERKEHR: "V",
                WOHNEN: "W",
                BERUF: "B"
            },

            BEAMTER_TEXT: {
                B: "öffentlicher Dienst",
                N: ""
            }
        };
    },

    methods: {
        beamterKeyToText: function (value) {
            if (this.BEAMTER[value]) {
                return this.BEAMTER_TEXT[value];
            } else {
                return "";
            }
        },
        beamterBoolToKey: function (value) {
            if (value === true) {
                return this.BEAMTER.B;
            } else {
                return this.BEAMTER.N;
            }
        },
        praemienName(zahlweise) {
            let ret = 'Beitrag';
            switch(zahlweise) {
                case '1': 
                    ret = 'Jahresbeitrag';
                break;
                case '2': 
                ret = 'Halbjahresbeitrag';
                break;
                case '4':
                    ret = 'Vierteljahresbeitrag';
                break;
                case '12': 
                ret = 'Monatsbeitrag';
                break;
            }
            return ret;
        }
    }
};
